<script lang="ts">
    import { faEdit, faUser } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'
    import type { KPIIndicators_iCommunication, KPIIndicators_iConversion, KPIIndicators_iSchedule } from '../../modules/use-cases/kpi-indicators'
    const dispatch = createEventDispatcher()

    export let details: KPIIndicators_iCommunication | KPIIndicators_iSchedule | KPIIndicators_iConversion
    export let detailsType: 'contacted' | 'connected' | 'added' | 'show' | 'rebuy' | 'converted' | 'direct' | 'all' | 'old'

    let loaded = false
    let showWindowConversionAlert = false

    onMount(async () => {
        loaded = true
        const _details = JSON.parse(JSON.stringify(details))
        if (details.type === 'communications') {
            await loadCommunication(_details as KPIIndicators_iCommunication)
        }
        if (_details.type === 'appointments') {
            await loadSchedule(_details as KPIIndicators_iSchedule)
        }
        if (_details.type === 'conversions') {
            await loadConversion(_details as KPIIndicators_iConversion)
        }
    })

    function showDetails(personId: string) {}

    let grid: GridClass = new GridClass()

    async function loadCommunication(details: KPIIndicators_iCommunication) {
        let entities = details.persons
        if (detailsType === 'connected') {
            entities = entities.filter((el) => details.connected.some((con) => el.personId === con))
        }
        details.persons = await window.api.utils.utils.assignPersonsFromObject(details.persons)
        entities = await assignReferral(entities)
        // grid
        grid = new GridClass()
        // grid head
        grid.title = ''
        grid.subtitle = ''
        grid.fontSize = '15px'
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Pessoa', type: GridColTypeEnum.string, maxLength: 90 }))
        grid.cols.push(new GridCol({ content: 'Origem' }))
        grid.cols.push(new GridCol({ content: 'Primeiro contato', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Último contato', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const firstContact = item.all.reduce(
                (min, item) => (min.getTime() < new Date(item.externalDate).getTime() ? min : new Date(item.externalDate)),
                new Date(2099, 0, 0),
            )
            const lastContact = item.all.reduce(
                (max, item) => (max.getTime() > new Date(item.externalDate).getTime() ? max : new Date(item.externalDate)),
                new Date(0, 0, 0),
            )
            const btnDetails = new GridButton({
                callback: () => showDetails(item.personId),
                icon: faEdit,
                label: 'Detalhes',
            })
            const btnPerson = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
                label: 'Pessoa',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.person?.name || '' })
            line.slots.push({ content: item.person?.referral?.label || '[não informado]' })
            line.slots.push({ content: firstContact })
            line.slots.push({ content: lastContact })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }

        //loadChart()
    }

    async function loadSchedule(details: KPIIndicators_iSchedule) {
        let entities = details.persons
        if (detailsType === 'show') {
            entities = entities.filter((el) => details.show.some((con) => el.personId === con))
        }
        entities = await window.api.utils.utils.assignPersonsFromObject(entities)
        entities = await assignReferral(entities)
        // grid
        grid = new GridClass()
        // grid head
        grid.title = ''
        grid.subtitle = ''
        grid.fontSize = '15px'
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Pessoa', type: GridColTypeEnum.string, maxLength: 90 }))
        grid.cols.push(new GridCol({ content: 'Origem' }))
        grid.cols.push(new GridCol({ content: 'Agendamento mais recente', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const lastAppointment = item.all.reduce(
                (max, item) => (max.getTime() > new Date(item.start).getTime() ? max : new Date(item.start)),
                new Date(0, 0, 0),
            )
            const btnDetails = new GridButton({
                callback: () => showDetails(item.personId),
                icon: faEdit,
                label: 'Detalhes',
            })
            const btnPerson = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
                label: 'Pessoa',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.person?.name || '' })
            line.slots.push({ content: item.person?.referral?.label || '[não informado]' })
            line.slots.push({ content: lastAppointment })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }

        //loadChart()
    }

    async function loadConversion(details: KPIIndicators_iConversion) {
        let entities = details.persons
        if (detailsType === 'direct') {
            entities = entities.filter((el) => details.direct.some((con) => el.personId === con))
        }
        if (detailsType === 'converted') {
            showWindowConversionAlert = true
            entities = entities.filter((el) => details.converted.some((con) => el.personId === con))
        }
        if (detailsType === 'rebuy') {
            entities = entities.filter((el) => details.rebuy.some((con) => el.personId === con))
        }
        if (detailsType === 'old') {
            entities = entities.filter((el) => details.old.some((con) => el.personId === con))
        }
        if (detailsType === 'all') {
            entities = entities.filter((el) => details.all.some((con) => el.personId === con))
        }

        entities = await window.api.utils.utils.assignPersonsFromObject(entities)
        entities = await assignReferral(entities)

        // grid
        grid = new GridClass()
        // grid head
        grid.title = ''
        grid.subtitle = ''
        grid.fontSize = '15px'
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Pessoa', type: GridColTypeEnum.string, maxLength: 90 }))
        grid.cols.push(new GridCol({ content: 'Origem' }))
        grid.cols.push(new GridCol({ content: 'Cadastro', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Compra mais recente', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const lastBuy = item.all.reduce(
                (max, item) => (max.getTime() > new Date(item.createdAt).getTime() ? max : new Date(item.createdAt)),
                new Date(0, 0, 0),
            )
            const btnDetails = new GridButton({
                callback: () => showDetails(item.personId),
                icon: faEdit,
                label: 'Detalhes',
            })
            const btnPerson = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
                label: 'Pessoa',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.person?.name || '' })
            line.slots.push({ content: item.person?.referral?.label || '[não informado]' })
            line.slots.push({ content: item.person?.createdAt })
            line.slots.push({ content: lastBuy })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }

        //loadChart()
    }

    async function assignReferral(data) {
        const refs = await window.api.events.referrals.getAll(undefined, 600)
        for (const item of data) {
            if (item.person?.referralId) {
                item.person.referral = refs.find((el) => el.referralId === item.person.referralId)
            }
        }
        return data
    }

    // let chart: ChartData
    // function loadChart() {
    //     if (!entries) entries = []
    //     chart = new ChartData()
    //     let items: { label: string; value: number }[] = []
    //     for (const el of entries) {
    //         items.push({
    //             label: el.description?.length > 30 ? el.description.substring(0, 27) + '...' : el.description,
    //             value: el.value,
    //         })
    //     }
    //     items.sort(window.api.utils.utils.dynamicSortMultiple(false, 'value')).reverse()
    //     chart.categories = [...items.map((el) => el.label || '')]
    //     chart.type = 'donut'
    //     chart.title = entries.length > 0 ? entries[0].category.label : '-'
    //     chart.series = [...items.map((el) => el.value)]

    //     chart = chart
    // }
</script>

<div>
    <!-- <Zchart data={chart} class="m-3 mb-0"></Zchart> -->
    <Zgrid {grid} class="mt-3 m-3" />
</div>

<style>
</style>
